export default {
  name: "mLuckyItem",
  props: {
    isSoon: {
      default: false
    },
    isNew: {
      default: false
    },
    url: {
      default: ""
    },
    name: {
      default: ""
    }
  }
};